import flatten from "lodash-es/flatten";
import { Reducer } from "redux";

import {
    STROLLER_ALL_REVIEWS_GALLERY_FETCH_FAILURE,
    STROLLER_ALL_REVIEWS_GALLERY_FETCH_REQUEST,
    STROLLER_ALL_REVIEWS_GALLERY_FETCH_SUCCESS,
    StrollerAllReviewsGalleryFetchFailureAction,
    StrollerAllReviewsGalleryFetchRequestAction,
    StrollerAllReviewsGalleryFetchSuccessAction,
} from "@/mk2/apps/strollers/containers/StrollerAllReviewsGallery/StrollerAllReviewsGallery.actions";
import { tupdate } from "@/mk2/helpers/types";
import { LoadingState, loadingState } from "@/mk2/reducers/loadingState";
import { StrollerUserReviewEntity, StrollerUserReviewSchema } from "@/mk2/schemas";
import { getDenormalizedEntities } from "@/mk2/selectors";

export interface StrollerAllReviewsGalleryState {
    loadingState: LoadingState;
    strollerId: number | null;
    strollerReviewIds: number[];
    strollerReviewsPhotoIds: number[];
}

export const initialStrollerAllReviewsGalleryState = {
    loadingState: LoadingState.INIT,
    strollerId: null,
    strollerReviewIds: [],
    strollerReviewsPhotoIds: [],
};

export interface StrollersAllReviewsGalleriesState {
    pages: {
        [strollerSlug: string]: StrollerAllReviewsGalleryState;
    };
}

export const initialStrollersAllReviewsGalleriesState: StrollersAllReviewsGalleriesState = {
    pages: {},
};

declare type StrollerAllReviewsGalleryReducerAction =
    | StrollerAllReviewsGalleryFetchRequestAction
    | StrollerAllReviewsGalleryFetchSuccessAction
    | StrollerAllReviewsGalleryFetchFailureAction;

export const strollersAllReviewsPhotosGalleriesReducer: Reducer<
    StrollersAllReviewsGalleriesState,
    StrollerAllReviewsGalleryReducerAction
> = (state = initialStrollersAllReviewsGalleriesState, action) => {
    switch (action.type) {
        case STROLLER_ALL_REVIEWS_GALLERY_FETCH_REQUEST:
        case STROLLER_ALL_REVIEWS_GALLERY_FETCH_FAILURE: {
            const strollerSlug = action.strollerSlug;
            return tupdate(state, {
                pages: tupdate(state.pages, {
                    [strollerSlug]: tupdate(
                        state.pages[strollerSlug] || initialStrollerAllReviewsGalleryState,
                        {
                            loadingState: loadingState(undefined, action),
                        },
                    ),
                }),
            });
        }

        case STROLLER_ALL_REVIEWS_GALLERY_FETCH_SUCCESS: {
            const strollerSlug = action.strollerSlug;
            return tupdate(state, {
                pages: tupdate(state.pages, {
                    [strollerSlug]: tupdate(
                        state.pages[strollerSlug] || initialStrollerAllReviewsGalleryState,
                        {
                            loadingState: loadingState(undefined, action),
                            strollerId: action.response.result.stroller,
                            strollerReviewIds: action.response.result.strollerReviews,
                            // collect all review photos
                            strollerReviewsPhotoIds: flatten(
                                getDenormalizedEntities<StrollerUserReviewEntity>(
                                    action.response,
                                    StrollerUserReviewSchema,
                                    action.response.result.strollerReviews,
                                ).map((review) => review.photos),
                            ).map((photo) => photo.id),
                        },
                    ),
                }),
            });
        }

        default:
            return state;
    }
};
